import { Team } from "./teams.models";

export type ImgData = {
  pictureUrl: string;
  pictureFile: File;
};

export type TeamAvatarModalData = {
  imgData: ImgData;
  team: Team;
  isUploadMediaAvatarEnabled: boolean;
};

// The ngx-image-cropper library only accepts these image types
export const ALLOWED_IMAGE_TYPES = ".png, .jpg, .jpeg, .bmp, .gif, .tiff, .webp, .x-icon, .vnd.microsoft.icon";
